import { RpcService } from 'rpc';

export interface ITimesyncService extends RpcService {
	server_time(params: { clienttime: number }): Promise<any>;
}

const baseurl = window.hcstatic.portal_url;

const svc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${baseurl}/@@timesync.rpc`,

	services: {
		server_time: {
			parameters: [
				{
					name: 'clienttime',
					type: 'integer',
					optional: false
				}
			]
		}
	}
}) as ITimesyncService;

export default svc;
